import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
      resources:{
          en: {
              translations: {
              }
          },
          id: {
              translations: {
                "Dashboard" : "Dashboard",
                "Account settings": "Pengaturan Akun",
                "Change Password": "Ubah Password",
                "Master Data":"Data Master",
                "Gym":"Gym",
                "Member":"Anggota",
                "Period":"Paket",
                "Trainer":"Pelatih",
                "Studio":"Studio",
                "Facilities":"Fasilitas",
                "Annoucement":"Pengumuman",
                "Products":"Barang",
                "Product" : "Barang",
                "Supplier" : "Supplier",
                "Mount" : "Satuan",
                "Category" : "Kategori",
                "Personal Training":"Pelatihan",
                "Contract" : "Kontrak",
                "Schedule" : "Jadwal Latihan",
                "Calendar" : "Kalender",
                "Finance & Transaction":"Keuangan & Transaksi",
                "Sales & Finance":"Penjualan",
                "Finance" : "Keuangan",
                "Cash Flow" : "Arus Kas",
                "Buy Product":"Stok Ulang Barang",
                "Sell Product":"Jual Barang",
                "Income":"Pendapatan",
                "Expenditure":"Pengeluaran",
                "Report":"Laporan",
                "Language":"Bahasa",
                "Profile":"Profil",
                "Settings":"Pengaturan",
                "Notifications":"Notifikasi",
                "See all notifications":"Lihat semua notifikasi",
                "Cashier":"P.O.S",
                "Good Morning":"Selamat Pagi",
                "Good Afternoon":"Selamat Siang",
                "Good Evening":"Selamat Malam",
                "Membership Balance":"Saldo dari Anggota",
                "Grimax Balance" : "Saldo Grimax",
                "Membership" : "Keanggotaan",
                "Profit from Products":"Pendapatan dari barang",
                "Today's Income":"Pendapatan hari ini",
                "Total Income":"Total Pendapatan",
                "Total Expenditure" : "Total Pengeluaran",
                "Create new Transaction":"Buat transaksi baru",
                "Member Activation":"Aktifasi Member",
                "Today's Transaction":"Transaksi Hari ini",
                "Latest Member Transaction":"Transaksi Terakhir Anggota",
                "Latest Product Transaction":"Transaksi Trakhir Barang",
                "Create New":"Buat Baru",
                "Log Out":"Keluar",
                "Member List":"Daftar Anggota",
                "Add Member":"Tambah Anggota",
                "All":"Semua",
                "Active":"Aktif",
                "No Active":"Tidak Aktif",
                "New":"Baru",
                "Extend":"Perpanjang",
                "Visit":"Visitasi",
                "Expire":"Habis",
                "Full Name":"Nama Lengkap",
                "Contact":"Kontak",
                "Action":"Aksi",
                "not found":"tidak ditemukan",
                "Joined":"Gabung",
                "Done" : "Selesai",
                "Personal info":"Informasi Personal",
                "Gender":"Jenis Kelamin",
                "Date of Birth":"Tanggal Lahir",
                "Work":"Pekerjaan",
                "ID Member":"ID Anggota",
                "Phone":"Telepon",
                "Email":"Email",
                "Photo":"Foto",
                "Cancel":"Batal",
                "Male":"Pria",
                "Female":"Wanita",
                "Name cannot be empty!":"Nama harus diisi!",
                "Phone format not valid!":"Format telepon tidak valid!",
                "Email format not valid!":"Format email tidak valid!",
                "Show Trial Data" : "Tampilkan Data Trial",
                "Edit Member":"Ubah Data Anggota",

                "Activation":"Aktifasi",
                "Activation Date":"Tanggal Aktifasi",
                "Please fill up period, status and activation date!":"Mohon isi paket, status dan tanggal aktifasi!",
                "Since":"Sejak",
                "Member Card":"Kartu Anggota",
                "Member Check - In" : "Check - In Anggota",
                "Send Card":"Kirim Kartu",
                "Print Card":"Cetak Kartu",

                "Period List":"Daftar Paket",
                "Range":"Jangka",
                "Price":"Harga",
                "Add Period":"Tambah Paket",
                "Month":"Bulan",
                "Day":"Hari",
                "Period Name":"Nama Paket",
                "Period Type":"Tipe Paket",
                "Number of":"Jumlah",
                "Edit Period":"Ubah data Paket",
                "Trainer List":"Daftar Pelatih",
                "Add Trainer":"Tambah Pelatih",
                "Description":"Deskripsi",
                "ID Trainer":"ID Pelatih",
                "Edit Trainer":"Ubah data Pelatih",
                "Trainer Card":"Kartu Pelatih",
                "Back":"Kembali",
                "Add Studio":"Tambah Studio",
                "Studio List":"Daftar Studio",
                "Color":"Warna",
                "Studio Name":"Nama Studio",
                "Pick a Color":"Pilih Warna",
                "Edit Studio":"Ubah data Studio",
                "Description cannot be empty!":"Deskripsi harus diisi!",
                "Facilities / Equipment List":"Daftar Alat / Fasilitas",
                "Facility":"Fasilitas",
                "Add Facility":"Tambah Fasilitas",
                "Facility Name":"Nama Fasilitas",
                "Select Studio":"Pilih Studio",
                "Edit Facility":"Ubah data Fasilitas",
                "Studio cannot be empty!":"Studio harus diisi!",

                "Product List":"Daftar Produk",
                "Stock":"Stok",
                "Add Product":"Tambah Barang",
                "Product Name":"Nama Barang",
                "Edit Product":"Ubah data Barang",
                "Category cannot be empty!":"Kategori harus diisi!",
                "Price cannot be empty!":"Harga harus diisi!",
                "Mount cannot be empty!":"Satuan harus diisi!",

                "Supplier List":"Daftar Supplier",
                "Supplier Name":"Nama Supplier",
                "Address cannot be empty!":"Alamat harus diisi!",
                "Add Supplier":"Tambah Supplier",
                "Edit Supplier":"Ubah data Supplier",
                "Address":"Alamat",

                "Mount List":"Daftar Satuan",
                "Mount Name":"Nama Satuan",
                "Add Mount":"Tambah Satuan",
                "Edit Mount":"Ubah data Satuan",

                "Category List":"Daftar Kategori",
                "Category Name":"Nama Kategori",
                "Add Category":"Tambah Kategori",
                "Edit Category":"Ubah data Kategori",

                "Contract List":"Daftar Kontrak",
                "Request Contract":"Pengajuan Kontrak",
                "Trainer - Member":"Pelatih - Anggota",
                "Approved":"Disetujui",
                "Rejected":"Ditolak",
                "Waiting Approval":"Menunggu Persetujuan",
                "Sharing Profit":"Bagi Hasil",
                "Training":"Pelatihan",
                "Session for":"Sesi untuk",
                "Days":"Hari",
                "Contract Amount":"Harga Kontrak",
                "Agreement":"Perjanjian",
                "Gym Share":"Pembagian Gym",
                "Trainer Share":"Pembagian Pelatih",
                "Payment":"Pembayaran",
                "Approved / Active":"Disetujui",

                "ID Contract":"ID Kontrak",
                "Start":"Mulai",
                "Active Trainer":"Pelatih Aktif",
                "Active Member":"Anggota Aktif",
                "End":"Selesai",
                "Total Session":"Total Sesi",
                "Profit Agreement":"Perjanjian Keuntungan",
                "Contract Shares":"Pembagian",
                "Total Trainer":"Total Pelatih",
                'Trainer cannot be empty!':"Pelatih harus dipilih!",
                "Member cannot be empty!":"Anggota harus dipilih!",
                "Start Date cannot be empty!":"Tanggal mulai harus diisi!",
                "End Date cannot be empty!":"Tanggal selesai harus diisi!",
                "Total Session cannot be empty!":"Total sesi harus diisi!",
                "Agreement cannot be empty!":"Perjanjian harus dipilih!",
                "Shares cannot be empty!":"Pembagian harus diisi!",

                "Purchased List":"Pembelian Barang",
                "Amount":"Harga",
                "Date":"Tanggal",
                "Transaction":"Transaksi",
                "Current Stock":"Stok yang ada",
                "Purchase Stock":"Pembelian stok",
                "Expenditure cannot be empty!":"Pengeluaran harus diisi!",
                "Date cannot be empty!":"Tanggal harus diisi!",
                "Supplier cannot be empty!":"Supplier harus diisi!",
                "Product cannot be empty!":"Barang harus diisi!",
                "New Stock cannot be empty!":"Stok baru harus diisi!",

                "Please choose item & fill qty":"Mohon pilih produk dan isi qty",
                "Stock not available":"Stok Habis",
                "Empty Cart":"Keranjang Kosong",

                "Income List":"Daftar Pendapatan",
                "Add Income":"Tambah Pendapatan",

                "Expenditure List":"Daftar Pengeluaran",
                "Add Expenditure":"Tambah Pengeluaran",

                "Since | Date of Join":"Sejak | Tanggal Gabung",
                "Card":"Kartu",

                "Users":"Pengguna",
                "User List":"Daftar Pengguna",
                "Add User":"Tambah Pengguna",
                "User Log":"Aktifitas Pengguna",
                "Recent Activity List":"Daftar Aktifitas Terakhir",
                "Activity":"Aktifitas",

                "Report Form" : "Form Laporan",
                "Sales & Activation Income":"Pendapatan penjualan & aktifasi anggota",
                "Search":"Cari",
                "Current Password":"Kata Sandi Lama",
                "New Password":"Kata Sandi Baru",
                "Confirmation":"Konfirmasi",
                "Paid":"Lunas",

                "These are transaction from the last 3 months, if you want to see an older data, you can access it through Report menu" : "Berikut adalah data transaksi dalam kurung waktu 3 bulan, jika anda ingin melihat data lebih lama, tersedia pada menu Laporan",
                "Please click add button to insert new data" : "Silahkan klik tombol tambah untuk menambahkan data baru",

                "Show membership data" : "Tampilkan Data Keanggotaan",
                "Show Income Transaction" : "Tampilkan Transaksi Pendapatan",
                "Show Expenditure Transaction" : "Tampilkan Transaksi Pengeluaran",
                "Title" : "Judul",
                "Receiver":"Penerima",
                "Payment Method" : "Metode Bayar",
                "Please fill up payment method!" : "Mohon isi metode pembayaran",
                "From" : "Dari",
                "To" : "Sampai",
                "You can show dashboard data based on a period of time by filling in the date fields." : "Anda dapat menampilkan data dashboard jangka waktu dengan mengisi tanggal.",
                "You can show data based on a period of time by filling in the date fields." : "Anda dapat menampilkan data jangka waktu dengan mengisi tanggal.",
                "Displaying dashboard data": "Menampilkan data dashboard",
                "Showing data": "Menampilkan data",
                "if there is a system error we are ready to support you 12 hours a day from 10.00 - 22.00, please contact us if you need our support" : "jika terjadi kesalahan sistem kami siap men-support anda 12 jam setiap harinya dari pukul 10.00 - 22.00, silahkan hubungi kami jika anda membutuhkan support kami",
                "Contact Us":"Hubungi Kami",
                "QR Transaction" : "Transaksi QR",
                "Bank Transfer" : "Transfer Rekening",
                "Cash Transaction" : "Transaksi Tunai",
                "Dashboard Period - Date Range" : "Dashboard Periode - Jangka Waktu",
                "We recommend that you perform cache clearing periodically" : "Disarankan untuk selalu lakukan clean cache pada browser anda",
                "Available Balance" : "Saldo Tersedia",
                "Help Center" : "Pusat Bantuan"
            }
          }
      },
      fallbackLng: "en",
    debug: true,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false
    }
  });

  export default i18n;